"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLabelCartErrorEnum = void 0;
var EventLabelCartErrorEnum;
(function (EventLabelCartErrorEnum) {
    EventLabelCartErrorEnum["InvoiceIsUnavailable"] = "Selected payment method not available_Invoice";
    EventLabelCartErrorEnum["CreditCardIsUnavailable"] = "Selected payment method not available_Creditcard";
    EventLabelCartErrorEnum["PayPalIsUnavailable"] = "Selected payment method not available_Paypal";
    EventLabelCartErrorEnum["AmazonPayIsUnavailable"] = "Selected payment method not available_AmazonPay";
    EventLabelCartErrorEnum["SofortIsUnavailable"] = "Selected payment method not available_Sofortueberweisung";
    EventLabelCartErrorEnum["FallbackPaymentAmazon"] = "FallbackPayment_Amazon";
    EventLabelCartErrorEnum["FallbackPaymentPaypal"] = "FallbackPayment_Paypal";
})(EventLabelCartErrorEnum || (exports.EventLabelCartErrorEnum = EventLabelCartErrorEnum = {}));
//# sourceMappingURL=EventLabelCartErrorEnum.js.map